<template>
  <div class="main">
    <img src="../assets/mascot.png" alt="" class="mascot">
    <div class="box-area">
      <img src="../assets/zju.png" alt="" class="zju-logo">
      <img src="../assets/110.png" alt="" class="title-110">
      <img src="../assets/text.png" alt="" class="act-text">
    </div>
    <div class="bottom-btn">
      <div class="btn" @click="goEarth">点亮全球</div>
      <div class="btn" @click="goMini">医路同行</div>
    </div>
  </div>
</template>

<script>
import wx from "wx";
import {wxReq} from "../common/wxTool";
// import {getInfo} from "../common/storage";

export default {
  name: "Invite",
  data() {
    return {
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.wxInit();
    },
    wxInit() {
      wxReq(() => {
        let imgUrl = 'https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/zd/yltx/logo.jpg';
        let title = "迎庆浙大医学院110周年";
        let desc = "2022年4月22日至5月28日 “医路同行 健康悦跑”邀你同行";
        let link = location.origin + location.pathname;
        wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title, // 分享标题
            desc, // 分享描述
            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl // 分享图标
          });
          wx.updateTimelineShareData({
            title, // 分享标题
            link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl // 分享图标
          });
        });
      });
    },
    goEarth() {
      // location.href = 'https://xiaoqing-1302345365.cos.ap-nanjing.myqcloud.com/topic/%08zjusm_lightup_world/index.html';
      location.href = 'http://zsdfz.zj-qq.cn/light.html';
    },
    goMini() {
      this.$showModal({
        title: '长按识别小程序码参与活动',
        img: require('../assets/mini-qr.png')
      })
    }
  }
}
</script>

<style scoped lang="less">
.main {
  position: absolute;
  top: 0;
  left: 0;
  padding-bottom: constant(safe-area-inset-bottom); /*兼容 IOS<11.2*/
  padding-bottom: env(safe-area-inset-bottom); /*兼容 IOS>11.2*/
  width: 100%;
  height: 100%;
  background: url(../assets/back.png) center no-repeat;
  background-size: cover;
  box-sizing: border-box;
  overflow: hidden;
  line-height: 1;
}

.run-back {
  position: absolute;
  top: -126px;
  left: 0;
  width: 100%;
  height: 1149px;
}
.box-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-top: 84px;
  .enter-btn {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 340px;
    margin: 0 auto;
  }
}
.title-110 {
  position: relative;
  margin-top: 58px;
  width: 610px;
  height: 173px;
}
.zju-logo {
  position: relative;
  width: 308px;
  height: 85px;
}
.name-input {
  position: relative;
  margin-top: 240px;
  padding: 6px 24px;
  width: 474px;
  border-radius: 50px;
  border: 4px solid #dacc96;
  background: #fff;
  outline: none;
  -webkit-appearance: none;
  font-size: 24px;
  line-height: 1.5;
}
.act-text {
  position: relative;
  margin-top: 71.25px;
  width: 315px;
  height: 420px;
}
.bottom-btn {
  display: flex;
  justify-content: space-between;
  position: absolute;
  left: 126px;
  right: 126px;
  bottom: 12.86458vh;
}

.btn {
  width: 200px;
  height: 60px;
  border-radius: 60px;
  background-color: #fff;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.6);
  font-size: 32px;
  font-weight: bold;
  text-align: center;
  line-height: 60px;
  color: #b43c89;
  &:active {
    background-color: #eee;
  }
}
.mascot {
  position: absolute;
  left: -182px;
  bottom: -94px;
  width: 549px;
  height: 644px;
  object-fit: contain;
}
</style>
